module.exports = __webpack_public_path__ + "static/3-f79fdc8767c19e2bfc86396474b20bda.jpg";